<ng-template #popoverTemplate>
  <div
    *ngIf="!isMobile; else mobileDateRange"
    class="calendar-container bg-fff"
  >
    <div class="calendars-body flex justify-content-between">
      <!-- First month -->
      <div class="calendar">
        <div
          class="calendar-header flex align_center fs-16 fw-600 lh-130 clr-333 ta_center m-b-8"
        >
          <button (click)="previousMonth()" class="m-r-40">
            <img [src]="images?.BACK" alt="previous" />
          </button>
          <span>{{ firstMonthStart | date : 'MMMM yyyy' }}</span>
        </div>
        <div class="calendar-grid">
          <div
            *ngFor="let day of daysOfWeek; trackBy: trackByDay"
            class="day-name fs-12 lh-130 fw-400 clr-999 ta_center"
          >
            {{ 'DATE_RANGE.' + day | translate }}
          </div>
          <div class="divider m-b-10 m-t-10"></div>
          <div
            *ngFor="let day of firstMonthDays; trackBy: trackByDay"
            (click)="selectDate(day?.date)"
            class="box flex-center flex_column ta_center clr-333 fs-12 fw-400 lh-130 c-pointer"
            (mouseenter)="onDateHover(day?.date)"
            (mouseleave)="clearHoverRange()"
            [ngClass]="{
              'opacity-half': day?.isDisabled,
              selected: day?.isSelected,
              'in-range': day?.isInRange || day?.isInHoverRange 
            }"
          >
            <div>{{ day?.date ? day.date?.getDate() : '' }}</div>
            <div class="today ta_center" *ngIf="day?.isToday"></div>
          </div>
        </div>
      </div>

      <!-- Second month -->
      <div class="calendar">
        <div
          class="calendar-header flex align_center justify-content-end fs-16 fw-600 lh-130 clr-333 ta_center m-b-8"
        >
          <span>{{ secondMonthStart | date : 'MMMM yyyy' }}</span>
          <button (click)="nextMonth()" class="m-l-40">
            <img class="next-icon" [src]="images?.BACK" alt="next" />
          </button>
        </div>
        <div class="calendar-grid">
          <div
            *ngFor="let day of daysOfWeek; trackBy: trackByDay"
            class="day-name fs-12 lh-130 fw-400 clr-999 ta_center"
          >
            {{ 'DATE_RANGE.' + day | translate }}
          </div>
          <div class="divider m-b-10 m-t-10"></div>
          <div
            *ngFor="let day of secondMonthDays; trackBy: trackByDay"
            (click)="selectDate(day?.date)"
            class="box flex-center flex_column ta_center clr-333 fs-12 fw-400 lh-130 c-pointer"
            (mouseenter)="onDateHover(day?.date)"
            (mouseleave)="clearHoverRange()"
            [ngClass]="{
              'opacity-half': day?.isDisabled,
              selected: day?.isSelected,
              'in-range': day?.isInRange || day?.isInHoverRange 
            }"
          >
            <div>{{ day?.date ? day.date?.getDate() : '' }}</div>
            <div class="today ta_center" *ngIf="day?.isToday"></div>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer for date display and actions -->
    <div class="calendars-footer flex_sb">
      <div class="footer-dates flex_sb fb-50">
        <div class="start-date">
          <div class="footer-date-label fs-12 fw-400 lh-130 clr-666">
            {{ 'DATE_RANGE.START_DATE' | translate }}
          </div>
          <div class="footer-date-value fs-14 fw-600 lh-140 clr-666">
            <ng-container *ngIf="selectedStartDate; else noStartDate">
              {{ selectedStartDate | date : 'dd-MM-yyyy' }}
            </ng-container>
            <ng-template #noStartDate> - </ng-template>
          </div>
        </div>
        <div class="clr-333 fs-12 lh-130 fw-400">
          {{ 'DATE_RANGE.TO' | translate }}
        </div>
        <div class="end-date">
          <div class="footer-date-label fs-12 fw-400 lh-130 clr-666">
            {{ 'DATE_RANGE.END_DATE' | translate }}
          </div>
          <div class="footer-date-value fs-14 fw-600 lh-140 clr-666">
            <ng-container *ngIf="selectedEndDate; else noEndDate">
              {{ selectedEndDate | date : 'dd-MM-yyyy' }}
            </ng-container>
            <ng-template #noEndDate> - </ng-template>
          </div>
        </div>
      </div>
      <div class="footer-actions">
        <button
          (click)="cancelSelection()"
          class="cancel-btn fs-14 lh-140 fw-600 clr-999"
        >
          {{ 'DATE_RANGE.CANCEL' | translate }}
        </button>
        <button
          class="apply-btn fs-14 fw-400 lh-130 color-white m-l-20"
          [disabled]="!selectedStartDate || !selectedEndDate"
          (click)="applySelection()"
        >
          {{ 'DATE_RANGE.APPLY' | translate }}
        </button>
      </div>
    </div>
  </div>
</ng-template>

<!-- For mobile -->

<ng-template #mobileDateRange>
  <div class="mpos-date-range bg-fff">
    <div class="">
      <div
        class="mpos-calendar-header flex_sb ta_center p-t-12 p-b-12 p-l-16 p-r-16"
      >
        <button (click)="previousMonth()" class="m-r-40">
          <img [src]="images?.BACK" alt="previous" />
        </button>
        <span class="fs-14 fw-600 lh-130 clr-666">{{
          firstMonthStart | date : 'MMMM yyyy'
        }}</span>
        <button (click)="nextMonth()" class="m-l-40">
          <img class="next-icon" [src]="images?.BACK" alt="next" />
        </button>
      </div>
      <div class="calendar-grid p-l-4 p-r-4">
        <div
          *ngFor="let day of daysOfWeek; trackBy: trackByDay"
          class="day-name fs-12 lh-130 fw-600 clr-999 ta_center p-t-12 p-b-12"
        >
          {{ 'DATE_RANGE.' + day | translate }}
        </div>
        <div class="divider m-b-4"></div>
        <div
          *ngFor="let day of firstMonthDays; trackBy: trackByDay"
          (click)="selectDate(day?.date)"
          class="box flex-center flex_column ta_center clr-333 fs-14 fw-400 lh-130 c-pointer"
          [ngClass]="{
            'opacity-half': day?.isDisabled,
            selected: day?.isSelected,
            'in-range': day?.isInRange
          }"
        >
          <div>{{ day?.date ? day.date?.getDate() : '' }}</div>
          <div class="today ta_center" *ngIf="day?.isToday"></div>
        </div>
      </div>
    </div>
    <div class="mpos-date-range-footer bg-fff">
      <div class="flex_sb">
        <div
          class="start-date mpos-footer-date flex-1 m-r-16"
          [ngClass]="{
            'selected-mpos-date': !selectedStartDate || selectedEndDate
          }"
        >
          <div class="clr-666 fs-12 lh-130 fw-400">
            {{ 'DATE_RANGE.START_DATE' | translate }}
          </div>
          <div class="clr-333 fs-14 lh-130 fw-600">
            <ng-container *ngIf="selectedStartDate; else noStartDate">
              {{ selectedStartDate | date : 'dd-MM-yyyy' }}
            </ng-container>
            <ng-template #noStartDate> - </ng-template>
          </div>
        </div>
        <div
          class="end-date mpos-footer-date flex-1"
          [ngClass]="{
            'selected-mpos-date': selectedStartDate && !selectedEndDate
          }"
        >
          <div class="clr-666 fs-12 lh-130 fw-400">
            {{ 'DATE_RANGE.END_DATE' | translate }}
          </div>
          <div class="clr-333 fs-14 lh-130 fw-600">
            <ng-container *ngIf="selectedEndDate; else noEndDate">
              {{ selectedEndDate | date : 'dd-MM-yyyy' }}
            </ng-container>
            <ng-template #noEndDate> - </ng-template>
          </div>
        </div>
      </div>
      <div class="flex_sb m-t-14">
        <button
          (click)="cancelSelection()"
          class="mpos-cancel-btn mpos-btn fs-14 lh-140 fw-600 wd-100 m-r-16"
        >
          {{ 'DATE_RANGE.CLOSE' | translate }}
        </button>
        <button
          class="apply-btn mpos-btn wd-100 fs-14 lh-130 fw-400 color-white"
          [disabled]="!selectedStartDate || !selectedEndDate"
          (click)="applySelection()"
        >
          {{ 'DATE_RANGE.APPLY' | translate }}
        </button>
      </div>
    </div>
  </div>
</ng-template>
